import { UserState } from "../../store/reducers/stageReducer";
import IncomeLocation from "../../components/OnboardingComponents/IncomeLocation";
import GetStarted from "../../components/OnboardingComponents/GetStarted";
import AgreementModal from "../../components/AgreementModal";
import StrategyVideo from "../../components/OnboardingComponents/StrategyVideo";
import ScheduleCall from "../../components/OnboardingComponents/ScheduleCall";
import OnboardingPresentation from "../../components/OnboardingComponents/OnboardingPresentation";

export interface OnboardingStep {
  order: number;        // controls step sequence — lower = earlier
  key: keyof UserState; // must match the stageReducer flag for this step
  permissionKey?: keyof ITilePermissions; // optional key for permission check (if different from the step key)
  render: () => JSX.Element; // use a render fn so props can be passed with full type safety
}

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    order: 1,
    key: "purlNdaChecked",
    render: () => <AgreementModal />,
  },
  {
    order: 2,
    key: "profileVerificationCompleted",
    permissionKey: "profileVerificationForm",
    render: () => <GetStarted />,
  },
  {
    order: 3,
    key: "incomeLocationCompleted",
    permissionKey: "incomeLocationForm", 
    render: () => <IncomeLocation />,
  },
  {
    order: 4,
    key: "videoComplete",
    permissionKey: "video",
    render: () => <StrategyVideo />,
  },
  {
    order: 5,
    key: "presentationComplete",
    permissionKey: "presentation",
    render: () => <OnboardingPresentation />,
  },
  {
    order: 6,
    key: "scheduleACallCompleted",
    permissionKey: "scheduleACallOnboarding",
    render: () => <ScheduleCall />,
  },
];
